export const NAVIGATE_TO = "NAVIGATE_TO";

